import { Loader } from '@googlemaps/js-api-loader'

export default class {
  constructor (config) {
    this.config = config
    this.google = {}
    this.map = {}
    this.markers = []
    this.infoWindow = {}
    this.userPosition = false
    this.geocoder = {}
  }

  async init () {
    this.google = await new Loader({
      apiKey: this.config.apiKey,
      libraries: ['places', 'geometry']
    }).load()
    this.infoWindow = new this.google.maps.InfoWindow();
    this.geocoder = new this.google.maps.Geocoder()
  }

  getGoogle () {
    return this.google
  }

  getMap () {
    return this.map
  }

  getPosition () {
    const center = this.map.getCenter()
    return {
      lat: center.lat(),
      lng: center.lng()
    }
  }

  async #getPosition(opts) {
    return new Promise((resolve, reject) => {
      if (window.navigator.geolocation)
        window.navigator.geolocation.getCurrentPosition(resolve, reject, opts)
      else
        reject()
    })
  }

  #fitMarkers () {
    if (this.markers.length === 0) return

    const bounds = new google.maps.LatLngBounds();
    for (const marker of this.markers) {
      bounds.extend({
        lat: parseFloat(marker.coordinates.lat),
        lng: parseFloat(marker.coordinates.lng)
      });
    }

    this.map.fitBounds(bounds);
  }

  #dropMarkers () {
    for (const marker of this.markers) {
      this.google.maps.event.clearInstanceListeners(marker);
      marker.setMap(null);
    }
    this.markers = []
  }

  #hideMarkers () {
    for (const marker of this.markers) {
      marker.setVisible(false);
    }
  }

  #buildMarker (markerData, showMoreDetails = false) {
    const moreDetails = `<a href='${markerData.href}'>${window.locatorTranslations.viewMore}</a>`

    const html = `
      <div class=''>
        <div class='uppercase text-sm'>${markerData.name}</div>
        <div class='text-xs pt-2'>${markerData.address}</div>
        <div class='text-xs pt-1'>${markerData.city}, ${markerData.vat}, ${markerData.country}</div>
        <div class='text-xs pt-1'>${markerData.tel}</div>
        <div class='text-xs pt-1'>${markerData.email}</div>
        <div class='text-xs pt-2'>${showMoreDetails ? moreDetails : ''}</div>
        <div class='text-xs pt-1'><a target='_blank' href='${markerData.directions}'>${window.locatorTranslations.directions}</a></div>
      </div>
    `

    // const icon = this.config.map.icons[markerData.type]

    var icon = this.config.map.icons[markerData.type]
    if( markerData.main_type == 'Y' ){
      var icon = this.config.map.icons['mainStore']
    }
    
    icon.anchor = new this.google.maps.Point(0, 0)

    const marker = new this.google.maps.Marker({
        ...markerData,
        position: {
          lat: parseFloat(markerData.coordinates.lat),
          lng: parseFloat(markerData.coordinates.lng)
        },
        map: this.map,
        icon,
        html,
        distance: 0
    });

    this.markers.push(marker)

    marker.addListener('mouseover', function () {
        this.setZIndex(100)
    })

    this.google.maps.event.addListener(marker, 'click', () => {
        this.infoWindow.setContent(marker.html)
        this.infoWindow.open(this.map, marker)
    })

    return marker
  }

  buildMapMarkers (markers) {
    this.#dropMarkers()

    for (const markerData of markers) {
      this.#buildMarker(markerData, markerData.type === 'showroom')
    }

    this.#fitMarkers()
  }

  async buildMap (showrooms, agents) {
    const position = await this.getCurrentPositionData()

    this.map = new this.google.maps.Map(document.querySelector(this.config.map.selector), {
      ...this.config.map.setup(this.google),
      center: position.coordinates,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    })
  }

  setAutocomplete (input) {
    return new this.google.maps.places.Autocomplete(input.get(0), this.config.search)
  }

  async getAddressCoordinates (country, city, address) {
    const data = await this.geocoder.geocode({
      address: `${country}${city ? `, ${city}` : ''}${address ? `, ${address}` : ''}`
    })

    return {
      lat: data.results[0].geometry.location.lat(),
      lng: data.results[0].geometry.location.lng()
    }
  }

  /**
   * Get position and render google geocode data. Implements fallbacks in case of issues
   * @returns Position coordinates and address
   */

  async getCurrentPositionData () {
    if (this.userPosition) return this.userPosition

    let position = this.config.map.initialPosition
    let address = this.config.map.defaultAddress

    try {
      const positionObj = await this.#getPosition(this.config.position)

      position = {
        lat: positionObj.coords.latitude,
        lng: positionObj.coords.longitude
      }
    } catch (e) {
      console.warn('Cannot get position, using fallback')
    }

    try {
      address = await this.geocoder.geocode({
        location: position
      })

      const country = address.results[0].address_components.find(pi => pi.types.includes('country'))
      const locality = address.results[0].address_components.find(pi => pi.types.includes('locality'))

      address = {
        country: country ? country.short_name : this.config.map.defaultCountry,
        locality: locality ? locality.short_name : this.config.map.defaultLocality
      }
    } catch (e) {
      console.warn('Cannot get address, using fallback')
    }

    this.userPosition = {
      coordinates: position,
      address
    }

    return this.userPosition
  }
}
